// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2UUExB7dLS3d336EcJQs3L","tableWrapper":"B2cbp81DXPF_0QxegVEBw"};